import { useSelectCustomers } from '@hooks';
import { L } from '@lib';
import { Select } from 'antd';
import { observer } from 'mobx-react';
import React, { useMemo, useState } from 'react';

interface IProps {
  placeholder?: string;
  status?: 'error' | 'warning';
  size?: 'small' | 'middle' | 'large';
  stickyHeader?: boolean;
  disabled?: boolean;
  /** Said in the list when a search finds nobody (nothing is said before anything is typed). */
  notFoundText?: string;
  onClear?: () => void;
  onSelect?: (id: string) => void;
  onDeselect?: (id: string) => void;
}

export const CustomerSelect: React.FC<IProps> = observer(
  ({ status, size, stickyHeader, disabled, notFoundText, onSelect, onDeselect }) => {
    const { customers, handleSearch } = useSelectCustomers();
    const [searched, setSearched] = useState('');

    const options = useMemo(() => {
      return customers.map((customer) => ({
        label: customer.fullname + ' - ' + customer.email,
        value: customer.id,
      }));
    }, [customers]);

    return (
      <Select
        allowClear
        showSearch
        notFoundContent={searched.trim().length > 0 ? (notFoundText ?? null) : null}
        filterOption={false}
        style={{ width: '100%' }}
        size={size}
        status={status}
        disabled={disabled}
        options={options}
        onSelect={onSelect}
        onSearch={(value) => {
          setSearched(value);
          handleSearch(value);
        }}
        onDeselect={onDeselect}
        placeholder={L('Enter customer name or email')}
        getPopupContainer={(stickyHeader && ((trigger: any) => trigger.parentElement)) || undefined}
      />
    );
  }
);
